const APIPath = "https://admin.magicalvacation.com";
export default APIPath;
